module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_discharging_solid.08d38838.svg";